export default __webpack_public_path__ + "static/media/eight.24d6966e.jpg";